import React, { useEffect, useState } from 'react';
import { Alert, Button, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import TextInput from '../../pages/components/inputs/TextInput';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Col, Icon } from '../Component';
import PhoneInput from 'react-phone-input-2';
import { ADD_TENANT_AGENCY_API } from '../../api/api_data';
import { tenant_auth_actions_helper } from '../../actions/actions_helper';
import { fail_add_tenant_agency, loading_add_tenant_agency, reset_add_tenant_agency, success_add_tenant_agency } from '../../reducers/auth_tenant/add_tenant_agency_Slice';
import { ADD_TENANT_AGENCIES_ERROR_MSG, ADD_TENANT_AGENCIES_SUCCESS_MSG } from '../../utils/error_success_messages';
import { messageToast } from '../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../utils/app_consts";


const initialState = { name: "", email_address: "", mobile_number: "" };

const AddAgencyModal = ({ tenant_info, user_info, isOpen, successFunction, closeModal }) => {

 const [open, setOpen] = useState(isOpen);
 const [loading, setLoading] = useState(false);
 const dispatch = useDispatch();
 const navigate = useNavigate();
 const [error, setError] = useState("");
 const [formData, setFormData] = useState(initialState);


 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 useEffect(() => {
  setOpen(isOpen);
  setFormData(initialState);

 }, [isOpen]);

 const handle_add_agency = () => {
  setError("");
  dispatch(tenant_auth_actions_helper(loading_add_tenant_agency, success_add_tenant_agency, fail_add_tenant_agency, ADD_TENANT_AGENCIES_ERROR_MSG, ADD_TENANT_AGENCIES_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${ADD_TENANT_AGENCY_API}`, formData));
 };

 // Listener
 const add_tenant_agency_listener = useSelector((state) => state.add_tenant_agency.add_tenant_agency);

 useEffect(() => {
  if (add_tenant_agency_listener.status !== app_consts.IDLE)
  {
   if (add_tenant_agency_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    if (add_tenant_agency_listener.status === app_consts.FAIL)
    {
     setLoading(false);
     setError(add_tenant_agency_listener.message);
     messageToast(add_tenant_agency_listener.message, app_consts.FAIL);
    } else if (add_tenant_agency_listener.status === app_consts.SUCCESS)
    {
     messageToast(add_tenant_agency_listener.message, app_consts.SUCCESS);
     navigate(`/${tenant_info?.url_prefix}/agencies/${add_tenant_agency_listener?.data?.id}`);
     successFunction();
    }
    dispatch(reset_add_tenant_agency());
   }
  }
 }, [add_tenant_agency_listener]);

 return (
  <>
   < Modal isOpen={open} className="modal-dialog-centered" size={"lg"} >
    <ModalHeader toggle={loading ? "" : closeModal}>Add Agency</ModalHeader>
    <ModalBody>
     <Row className="g-4">
      <TextInput
       label="Name"
       type="text"
       id_val="name"
       value={formData?.name}
       colSize="6"
       required
       name="name"
       handleChange={handleChange}
      />
      <TextInput
       label="Email Address"
       type="email"
       id_val="email_address"
       value={formData?.email_address}
       colSize="6"
       required
       name="email_address"
       handleChange={handleChange}
      />
      <Col lg="6">
       <div className="form-group">
        <div className="form-label-group">
         <label className="form-label" htmlFor="mobile_number">
          Mobile Number<span className='text-danger pr-2'>{`* `}</span>
         </label>
        </div>
        <div className="form-control-wrap">
         <PhoneInput
          country={"zm"}
          value={formData.mobile_number}
          onChange={(phone) => setFormData({ ...formData, mobile_number: phone })}
          copyNumbersOnly={false}
          inputStyle={{ width: '100%' }}
         />
        </div>
       </div>
      </Col>
     </Row>
     {error && (
      <div className="my-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )}
     <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
      <Button onClick={handle_add_agency} disabled={
       (loading) ||
       !(formData?.name && formData?.email_address && formData?.mobile_number)
      } color="primary">
       {loading ? <Spinner size="sm" color="light" /> : "Add Agency"}
      </Button>
     </Col>
    </ModalBody>
   </Modal>
  </>
 );
};

export default AddAgencyModal;